import GraphinaPublic from './graphina-public';
jQuery(function () {

    
    const GraphinaPublicMain = {
        'GraphinaPublic' : new GraphinaPublic(),
    };
    
    window['GraphinaPublicMain'] = GraphinaPublicMain;

})